export const CTCGlobalIcon = () => (
  <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" className="ctc-global-icon">
    <defs>
      <linearGradient id="pylonGradient" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" style={{ stopColor: '#67e8f9', stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: '#0e7490', stopOpacity: 1 }} />
      </linearGradient>
      <linearGradient id="fiberSignalGradient" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" style={{ stopColor: '#22d3ee', stopOpacity: 0 }} />
        <stop offset="50%" style={{ stopColor: '#a5f3fc', stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: '#22d3ee', stopOpacity: 0 }} />
      </linearGradient>
      <filter id="pylonGlow">
        <feGaussianBlur stdDeviation="1.5" result="coloredBlur" />
        <feMerge>
          <feMergeNode in="coloredBlur" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>

    {/* Ground/base */}
    <rect x="18" y="82" width="64" height="4" rx="1" fill="#164e63" className="pylon-ground" />

    {/* Tower legs (lattice frame) */}
    <g className="pylon-tower" filter="url(#pylonGlow)">
      <path
        d="M 50 20 L 30 82 M 50 20 L 70 82"
        stroke="url(#pylonGradient)"
        strokeWidth="3"
        strokeLinecap="round"
        className="pylon-leg"
      />
      <path
        d="M 40 35 L 60 35 M 36 50 L 64 50 M 33 65 L 67 65"
        stroke="url(#pylonGradient)"
        strokeWidth="2"
        strokeLinecap="round"
        className="pylon-brace"
      />
      <path
        d="M 40 35 L 60 50 M 60 35 L 40 50 M 36 50 L 64 65 M 64 50 L 36 65"
        stroke="url(#pylonGradient)"
        strokeWidth="1.2"
        opacity="0.7"
        className="pylon-lattice"
      />
    </g>

    {/* Cross-arms */}
    <g className="pylon-crossarms">
      <path
        d="M 26 28 L 74 28"
        stroke="url(#pylonGradient)"
        strokeWidth="3"
        strokeLinecap="round"
        className="crossarm crossarm-top"
      />
      <path
        d="M 32 42 L 68 42"
        stroke="url(#pylonGradient)"
        strokeWidth="2.5"
        strokeLinecap="round"
        className="crossarm crossarm-bottom"
      />
    </g>

    {/* Insulators */}
    <circle cx="26" cy="28" r="2" fill="#a5f3fc" className="insulator" />
    <circle cx="74" cy="28" r="2" fill="#a5f3fc" className="insulator" />
    <circle cx="32" cy="42" r="1.6" fill="#a5f3fc" className="insulator" />
    <circle cx="68" cy="42" r="1.6" fill="#a5f3fc" className="insulator" />

    {/* Conductor cables sagging between arms (fiber-sensed lines) */}
    <path
      d="M 26 28 Q 12 36 8 30"
      stroke="#22d3ee"
      strokeWidth="1.2"
      fill="none"
      opacity="0.8"
      className="conductor-cable"
    />
    <path
      d="M 74 28 Q 88 36 92 30"
      stroke="#22d3ee"
      strokeWidth="1.2"
      fill="none"
      opacity="0.8"
      className="conductor-cable"
    />

    {/* Fiber-optic telemetry signal pulse traveling the top cross-arm */}
    <g className="fiber-signal">
      <path
        d="M 26 28 L 74 28"
        stroke="url(#fiberSignalGradient)"
        strokeWidth="3"
        strokeLinecap="round"
        className="signal-sweep"
      />
      <circle cx="50" cy="18" r="2.2" fill="#67e8f9" className="signal-pulse" />
      <path
        d="M 44 18 Q 50 10 56 18"
        stroke="#a5f3fc"
        strokeWidth="1"
        fill="none"
        opacity="0.7"
        className="signal-wave signal-wave-1"
      />
      <path
        d="M 41 18 Q 50 6 59 18"
        stroke="#67e8f9"
        strokeWidth="0.8"
        fill="none"
        opacity="0.5"
        className="signal-wave signal-wave-2"
      />
    </g>
  </svg>
)

